// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"524e9379","453":"91ebcd77","455":"88b875d4"}[chunkId] + ".chunk.js";
};